import { AxiosResponse } from "axios";
import { Page } from "./page";

export class Response<T = any> {
  status: number;
  data: T;

  constructor(response: AxiosResponse) {
    this.status = response.status;
    this.data = response.data;
  }
}

export class ListResponse<T = any> {
  status: number;
  data: T[];

  constructor(response: AxiosResponse) {
    this.status = response.status;
    this.data = response.data.contents;
  }
}

export class PageResponse<T = any> {
  status: number;
  data: T[];
  page: Page;

  constructor(response: AxiosResponse) {
    this.status = response.status;
    this.data = response.data.contents;
    this.page = new Page(response.data);
  }
}
